import * as React from 'react'
import { ReactElement, useState } from 'react'
import { Menu, MenuDivider, MenuItemRadio, MenuList, MenuPopover, MenuTrigger, ToolbarButton } from '@fluentui/react-components'
import {
    bundleIcon,
    CalendarDayFilled,
    CalendarDayRegular,
    CalendarEmptyFilled,
    CalendarEmptyRegular,
    CalendarFilled,
    CalendarMonthFilled,
    CalendarMonthRegular,
    CalendarRegular,
    CalendarSearchFilled,
    CalendarSearchRegular,
} from '@fluentui/react-icons'
import { DateTime, Duration } from 'luxon'
import { useTranslation } from 'react-i18next'

const IntervalIcon = bundleIcon(CalendarSearchFilled, CalendarSearchRegular)
const MonthIcon = bundleIcon(CalendarDayFilled, CalendarDayRegular)
const QuarterIcon = bundleIcon(CalendarMonthFilled, CalendarMonthRegular)
const YearIcon = bundleIcon(CalendarFilled, CalendarRegular)
const AllIcon = bundleIcon(CalendarEmptyFilled, CalendarEmptyRegular)

export type IntervalProps = {
    interval: Interval
    setInterval: (interval: Interval) => void
    isLoading: boolean
}

export enum Interval {
    Month = 'Month',
    Quarter = 'Quarter',
    Year = 'Year',
    All = 'All',
}

export function getIntervalDate(interval: Interval): DateTime {
    if (Interval.All === interval) {
        return DateTime.fromISO('2000-01-01')
    }

    let date = DateTime.now()
    if (Interval.Year === interval) {
        date = date.minus(Duration.fromObject({ years: 1 }))
    } else if (Interval.Quarter === interval) {
        date = date.minus(Duration.fromObject({ months: 3 }))
    } else if (Interval.Month === interval) {
        date = date.minus(Duration.fromObject({ months: 1 }))
    }
    return date
}

export default function IntervalToolbarMenu(props: IntervalProps): ReactElement {
    const { t: translate } = useTranslation()

    const [checkedValues, setCheckedValues] = useState<Record<string, Interval[]>>({
        interval: [props.interval],
    })

    return (
        <Menu
            checkedValues={checkedValues}
            onCheckedValueChange={(e, d) => {
                setCheckedValues({ [d.name]: [d.checkedItems[0]] as Interval[] })
                props.setInterval(d.checkedItems[0] as Interval)
            }}
        >
            <MenuTrigger>
                <ToolbarButton icon={<IntervalIcon />} disabled={props.isLoading} />
            </MenuTrigger>
            <MenuPopover>
                <MenuList>
                    <MenuItemRadio icon={<MonthIcon />} name={'interval'} value={Interval.Month}>
                        {translate('email.filing.filter.interval.month')}
                    </MenuItemRadio>
                    <MenuItemRadio icon={<QuarterIcon />} name={'interval'} value={Interval.Quarter}>
                        {translate('email.filing.filter.interval.quarter')}
                    </MenuItemRadio>
                    <MenuItemRadio icon={<YearIcon />} name={'interval'} value={Interval.Year}>
                        {translate('email.filing.filter.interval.year')}
                    </MenuItemRadio>
                    <MenuDivider />
                    <MenuItemRadio icon={<AllIcon />} name={'interval'} value={Interval.All}>
                        {translate('email.filing.filter.interval.all')}
                    </MenuItemRadio>
                </MenuList>
            </MenuPopover>
        </Menu>
    )
}
